/** Keycloak console session (A1/A5): PKCE public client, silent token refresh. */
import Keycloak from 'keycloak-js'

const kcUrl = import.meta.env.VITE_KC_URL ?? 'http://localhost:8081'
const kcRealm = import.meta.env.VITE_KC_REALM ?? 'vbannagate'
const kcClient = import.meta.env.VITE_KC_CLIENT ?? 'vbannagate-console'

let instance: Keycloak | null = null

export function getKeycloak(): Keycloak {
  if (!instance) {
    instance = new Keycloak({ url: kcUrl, realm: kcRealm, clientId: kcClient })
  }
  return instance
}

export async function initAuth(timeoutMs = 8000): Promise<boolean> {
  const keycloak = getKeycloak()
  // If Keycloak (or the silent SSO check) stalls, fall back to unauthenticated
  // so the app still renders; the user can sign in via the gate button.
  const timeout = new Promise<false>(resolve =>
    setTimeout(() => resolve(false), timeoutMs))
  const authenticated = await Promise.race([
    keycloak.init({
      onLoad: 'check-sso',
      pkceMethod: 'S256',
      checkLoginIframe: false,
    }),
    timeout,
  ])
  if (authenticated) {
    setInterval(() => {
      void keycloak.updateToken(60).catch(() => {})
    }, 30_000)
  }
  return authenticated
  // keep the token fresh; on expiry the next API call re-authenticates via check-sso
  setInterval(() => {
    if (keycloak.authenticated) {
      void keycloak.updateToken(60).catch(() => {
        /* refresh failed; next request will redirect */
      })
    }
  }, 30_000)
  return authenticated
}

export function bearerToken(): string | null {
  return getKeycloak().token ?? null
}

/** REQ-021 (US-010): RP-initiated logout ends the realm SSO session; the
 * adapter discards local token state and the browser lands back on the
 * console origin, where check-sso now yields the login gate. */
export function signOut(): Promise<void> {
  return getKeycloak().logout({ redirectUri: window.location.origin })
}
